import { render } from "./OptimizationMethod.vue?vue&type=template&id=216d36f6&scoped=true"
import script from "./OptimizationMethod.vue?vue&type=script&lang=js"
export * from "./OptimizationMethod.vue?vue&type=script&lang=js"

import "./OptimizationMethod.vue?vue&type=style&index=0&id=216d36f6&lang=scss&scope=true"
import "./OptimizationMethod.vue?vue&type=style&index=1&id=216d36f6&scoped=true&lang=css"

import exportComponent from "/data/projects/dev_private_futurelab/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-216d36f6"]])

export default __exports__